export const LOCALE_NL = "nl";
export const LOCALE_EN = "en";